export type BadgeVariant = "active" | "inactive" | "passed" | "warning" | "alert" | "error";

const VARIANT_CONFIG: Record<BadgeVariant, { dot: string; color: string }> = {
  active:   { dot: "#10b981", color: "#065f46" },
  inactive: { dot: "#9ca3af", color: "#6b7280" },
  passed:   { dot: "#10b981", color: "#065f46" },
  warning:  { dot: "#f59e0b", color: "#92400e" },
  alert:    { dot: "#ef4444", color: "#991b1b" },
  error:    { dot: "#9ca3af", color: "#374151" },
};

export function DotBadge({ variant, label }: { variant: BadgeVariant; label?: string }) {
  const config = VARIANT_CONFIG[variant];
  return (
    <span
      style={{
        display: "inline-flex",
        alignItems: "center",
        gap: "6px",
        fontSize: "13px",
        fontWeight: 500,
        color: config.color,
      }}
    >
      <span
        style={{
          width: "8px",
          height: "8px",
          borderRadius: "50%",
          background: config.dot,
          flexShrink: 0,
        }}
      />
      {label ?? variant.charAt(0).toUpperCase() + variant.slice(1)}
    </span>
  );
}